import { BackordersDashboardFilters, BackordersDashboardTable } from "modules/BackordersDashboard/components";
import { useBackordersDashboardFilters } from "modules/BackordersDashboard/components/BackordersDashboardFilters/hooks";

export const BackordersDashboard = () => {
  useBackordersDashboardFilters();

  return (
    <>
      <BackordersDashboardFilters />
      <BackordersDashboardTable />
    </>
  );
};
